import { observable, action } from 'mobx';
import { IBrand, IRatingsReviewsConfig, Ii18n } from '../../interfaces/IRating';

export interface IConfig {
    ratingsReviewsConfig: IRatingsReviewsConfig;
    brand: IBrand;
    i18n: Ii18n;
}
export class Config {
    @observable public config: IConfig;

    @action
    public updateConfig(config: Partial<IConfig>) {
        this.config = { ...this.config, ...config };
    }
}
